import { Skeleton } from "@/components/ui/skeleton";

const WalletPassesSkeleton = () => (
  <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-4">
    <Skeleton className="h-4 w-28 mb-4" />
    <div className="flex items-center gap-3">
      <Skeleton className="h-12 w-12 rounded-lg" delay={40} />
      <Skeleton className="h-12 w-12 rounded-lg" delay={80} />
      <Skeleton className="h-3 w-16" delay={120} />
    </div>
  </div>
);

export default WalletPassesSkeleton;
